<template>
    <transition name="slide">
        <div class="bg-surface-secondary w-100">
            <add-note v-if="onaddnote" :onaddnote="onaddnote" @onclose="onaddnote = false" @onreload="RELOAD()"/>
            <header class="bg-surface-primary border-bottom">
                <div class="container-fluid py-4">
                    <div class="row align-items-center">
                        <div class="col">
                            <div class="d-flex align-items-center gap-4">
                                <div>
                                    <button type="button" class="btn-close text-xs" @click="$router.go(-1)"></button>
                                </div>
                                <div class="vr opacity-20 my-1"></div>
                                <h1 class="h4 ls-tight">Actualizar paquete - {{ data.type }}{{ data.id }}</h1>
                            </div>
                        </div>
                        <div class="col-auto">
                            <div class="hstack gap-2 justify-content-end">
                                <button @click="onaddnote = true" type="button" class="btn btn-h btn-dark px-3">
                                    <span class="pe-2">
                                        <i class="bi bi-card-checklist"></i>
                                    </span>
                                    <span>Notas</span>
                                </button>
                                <button @click="UPDATE()" type="button" class="btn btn-h btn-success px-3">
                                    <div class="spinner-border spinner-border-sm" role="status" v-if="count == 1">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                    <span v-else>Guardar cambios</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            <main class="py-6 bg-surface-secondary">
                <div class="container-fluid vstack gap-5">
                    <div class="border-bottom">
                        <v-tabs v-model="tab" @change="CHANGE()">
                            <v-tab :key="'package'">Paquete</v-tab>
                            <v-tab :key="'notes'">Notas</v-tab>
                            <v-tab :key="'history'">Historial</v-tab>
                            <v-tab :key="'invoice'" v-if="data.invoice">Facturación</v-tab>
                        </v-tabs>
                    </div>
                    <v-tabs-items v-model="tab">
                        <v-tab-item :key="'package'">
                            <package :data="data" :errors="errors" v-if="tab == 0" />
                        </v-tab-item>
                        <v-tab-item :key="'notes'">
                            <notes v-if="tab == 1" :onreload="onreload" @onreload="onreload = false" />
                        </v-tab-item>
                        <v-tab-item :key="'history'">
                            <history v-if="tab == 2" :onhistory="onhistory" @onhistory="onhistory = false"/>
                        </v-tab-item>
                        <v-tab-item :key="'invoice'" v-if="data.invoice">
                            <invoice v-if="tab == 3" :state="data.state_id" :invoice="data.invoice"/>
                        </v-tab-item>
                    </v-tabs-items>
                </div>
            </main>
        </div>
    </transition>
</template>
<script>
import Package from './forms/Package'
import Notes from './forms/Notes'
import AddNote from './modals/Notes'
import History from './forms/History'
import Invoice from './forms/Invoice'
export default {
    components: { Package, Notes, AddNote, History, Invoice },
    data() {
        return {
            open: [0],
            data: {},
            errors: {},
            count: 0,
            tab: Number(localStorage.getItem('tab_package_update') | 0),
            id: this.$route.params.id,
            onaddnote: false,
            onreload: false,
            onhistory: false,
            set: 0
        }
    },
    mounted() {
        this.set = this.tab
        this.INIT()
    },
    methods: {
        INIT: function () {
            let vue = this
            axios({ url: '/packages/' + vue.id, method: 'GET' })
                .then((resp) => {
                    vue.data = resp.data
                    if(vue.data.invoice && vue.set == 3){
                        vue.tab = 3
                        vue.CHANGE()
                    }
                })
                .catch((err) => {
                   let message = err.response ? err.response.data.message : err.message
                        vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                })
        },
        UPDATE: function () {
            let vue = this
            vue.count++
            if (vue.count == 1) {
                vue.errors = {}
                let form = new FormData()
                $.each(vue.data, function(key, item) {
                    if(item != null){
                        if(key == 'description'){
                            form.append(key, JSON.stringify(item))
                        }if(key == 'files'){
                            let count = 0
                            let files = item.filter(e => !e.id)
                            $.each(files, function(i, file) {
                                form.append('files[' + (count++) + ']', file)
                            })
                        }else{
                            form.append(key, item)
                        }
                    }
                })
                form.append('_method', 'PUT');
                axios({ url: '/packages/' + vue.id, method: 'POST', data: form })
                    .then((resp) => {
                        vue.$swal({ toast: true, icon: 'success', title: resp.data.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        if(vue.tab == 0){
                            vue.INIT()
                        }else if(vue.tab == 1){
                            vue.onreload = true
                        }else{
                            vue.onhistory = true
                        }
                    })
                    .catch((err) => {
                        if(err.response.status !== 422){
                            let message = err.response ? err.response.data.message : err.message
                            vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        } else {
                            vue.errors = err.response.data
                        }
                    })
                    .finally((resp) => {
                        vue.count = 0
                    })
            }
        },
        CHANGE: function() {
            let vue = this
            localStorage.setItem('tab_package_update', vue.tab)
        },
        RELOAD: function(){
            this.onreload = true
            this.onaddnote = false
        }
    },
}
</script>